@import '../../../../../../constants/spacing.module.less';

.loading-indicator-wrapper {
  align-items: center;
}

.loading-indicator {
  height: 60px;
}

.loading-indicator-text {
  color: var(--default--text-color--6);
}

.bullet-list {
  list-style: inside disc;
  margin-left: @space-8;
}

.bullet-list-item {
  display: list-item;
}
